import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NovidadesComponent } from './novidades/novidades.component';
import { RevistaAcademicaComponent } from './revista-academica/revista-academica.component';
import { ApresentacaoComponent } from './apresentacao/apresentacao.component';
import { EdicoesComponent } from './edicoes/edicoes.component';
import { FaleconoscoComponent } from './faleconosco/faleconosco.component';
import { BibliotecaComponent } from './biblioteca/biblioteca.component';
import { DocumentosComponent } from './documentos/documentos.component';
import { AtuacaoComponent } from './atuacao/atuacao.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    AtuacaoComponent,
    DocumentosComponent,
    BibliotecaComponent,
    NovidadesComponent,
    RevistaAcademicaComponent,
    ApresentacaoComponent,
    EdicoesComponent,
    FaleconoscoComponent
  ]
})
export class ViewsModule { }
